class AddressController {
    /*@ngInject*/
    constructor() {
        if (window.titles) {
            this.titles = window.titles.titles;
        }
        if (window.countries) {
            this.countries = window.countries.countries;
        }
        this.selectedTitle = '';
        this.title = {
            selected: null
        };
        this.selectedCountry = '';
        this.country = {
            selected: null
        };
        this.requestPending = false;
    }

    titleChanged(item) {
        this.selectedTitle = item.code;
    }

    countryChanged(item) {
        this.selectedCountry = item.code;
    }

    setTitleCode(code) {
        this.selectedTitle = code;
        for (let entry of this.titles) {
            if (code === entry.code) {
                this.title.selected = entry;
                break;
            }
        }
    }

    setCountryCode(code) {
        if (code) {
            this.selectedCountry = code;
            for (let entry of this.countries) {
                if (code === entry.code) {
                    this.country.selected = entry;
                    break;
                }
            }
        }
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default AddressController;
